import { useDynamicFormsCtx } from './useDynamicFormsCtx';
export const useMonaco = () => useDynamicFormsCtx().Monaco;
